import * as BECaller from '../../util/apiCaller';
import { setError, setSuccessMessage } from '../App/ErrorsActions';
import urlHelper from '../../util/url';

export const WALLBOARDS = 'WALLBOARDS_WALLBOARDS',
  LOADING = 'WALLBOARDS_LOADING',
  SUCCESS_SETTING = 'WALLBOARD_SETTING_SUCCESS',
  CREATE_SETTING = 'WALLBOARD_SETTING_CREATE',
  DELETE_SETTING = 'WALLBOARD_SETTING_DELETE',
  SUCCESS_VIEWS = 'WALLBOARDS_SUCCESS_VIEWS';

export function handleError(error) {
  return setError(error);
}

export function successSetting(data) {
  return {
    type: SUCCESS_SETTING,
    setting: data
  };
}

export function successCreate() {
  return {
    type: CREATE_SETTING
  };
}

export function successDelete() {
  return {
    type: DELETE_SETTING
  };
}

let options = {};

export function getViews(dashboardId) {
  return dispatch => {
    BECaller.api(`dashboards/${dashboardId}/views`, 'get').then(
      res => {
        const data = [...res.data];
        data.unshift({
          _id: 'default',
          name: 'All filters selected'
        });

        dispatch({
          type: SUCCESS_VIEWS,
          views: data
        });
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function getWallboards(dashboardId, opt = {}) {
  if (!_.isEmpty(opt)) {
    options = opt;
  }

  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });

    let url = `settings/list/${dashboardId}`;
    url += urlHelper.buildQuery(options);

    BECaller.api(url, 'get').then(
      data => {
        dispatch({
          type: WALLBOARDS,
          data
        });
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function getSetting(wallboardId) {
  return dispatch => {
    BECaller.api(`settings/display/${wallboardId}`, 'get').then(
      data => {
        dispatch(successSetting(data));
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function createSetting(dashboardId, data) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });
    return BECaller.api(`settings/display/${dashboardId}`, 'post', data).then(
      res => {
        dispatch(successCreate());
        dispatch(setSuccessMessage('Wallboard created successfully'));
        dispatch(getWallboards(dashboardId));
      },
      err => {
        dispatch(handleError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}

export function deleteWallboard(dashboardId, wallboardId) {
  return dispatch => {
    dispatch({
      type: LOADING,
      val: true
    });
    return BECaller.api(`settings/display/${dashboardId}/${wallboardId}`, 'delete').then(
      res => {
        dispatch(successDelete());
        dispatch(setSuccessMessage('Wallboard deleted successfully'));
        dispatch(getWallboards(dashboardId));
      },
      err => {
        dispatch(handleError(err));
        dispatch({
          type: LOADING,
          val: false
        });
      }
    );
  };
}
